import React from "react";
import Icon from "./Icon";

export default function LoadingState({
  label = "Loading",
  description = "Fetching the latest marketplace snapshot…",
  showRefresh = false,
  onRefresh,
}) {
  return (
    <div className="loading-block" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <div>
        <div className="loading-title">{label}</div>
        {description && <div className="loading-desc">{description}</div>}
        {showRefresh && onRefresh && (
          <button className="link-button" onClick={onRefresh}>
            <Icon name="refresh" />
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
